import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function SensorSelect({
  deviceOptions,
  selectedSensor,
  handleSensorChange,
  disabled,
}) {
  return (
    <Grid item xs={12} sm={4}>
      <FormControl fullWidth>
        <InputLabel>Sensor</InputLabel>
        <Select
          value={selectedSensor}
          onChange={handleSensorChange}
          label="Sensor"
          disabled={disabled}
        >
          <MenuItem value="Todos">Todos</MenuItem>
          {deviceOptions.flatMap((device) =>
            device.sensors.map((sensor) => (
              <MenuItem
                key={`${device.table}-${sensor.sensorNumber}`}
                value={`${device.table}-${sensor.sensorNumber}`}
              >
                {`${device.name} - ${sensor.sensorName}`}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Grid>
  );
}
